import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'

import { Form, Modal, ListGroup } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.adresInput = createRef()

    this.onClickHandler = this.onClickHandler.bind(this)
    this.onClickOutsideHandler = this.onClickOutsideHandler.bind(this)

    this.state = {
      adres: ``,
      delivery_arr: [],
      delivery: 0,
      delivery_loading: true,
      delivery_price: 0,
      modalShow: false,
      coords: [ 55.761447, 37.617181 ],
      isOpen: false
    }
  }

  setModalShow( stat ) {
    this.setState({
      modalShow: stat
    }, () => {
      if( stat ) this.startSdek()
    })
  }

  setDMethod( delivery ) {
    if( delivery == 1 || delivery == 2 ) {
      this.setModalShow( true )
    } else {
      this.setState({
        delivery: delivery
      }, () => {
        const { delivery, adres } = this.state
        this.props.setDelivery( delivery, 0, adres, 0 )
      })
    }
  }

  findAdres = ( adres ) => {
    const { delivery } = this.state
    if( delivery == 1 || delivery == 2 ) {
      this.setState({
        adres: adres,
        delivery: 0
      }, () => {
        this.props.setDelivery( 0, 0, 0, 0 )
      })
    } else {
      this.setState({
        adres: adres
      }, () => {
        const { delivery, adres } = this.state
        this.props.setDelivery( delivery, 0, adres, 0 )
      })
    }
  }

  onReady() {
    this.setState({
      delivery_loading: false
    })
  }

  onChoose( type, tarif, adres ) {
    this.setState({
      delivery: type == 'office' ? 1 : 2,
      adres: type == 'office' ? adres.name : adres.formatted
    }, () => {
      const { delivery, adres } = this.state
      this.props.setDelivery(
        delivery,
        tarif.tariff_code,
        adres,
        tarif.delivery_sum
      )
      this.setModalShow( false )
    })
  }

  startSdek() {
    const main = this,
    { cart } = this.props,
    { coords } = this.state,
    goods = []

    cart.map(( product ) => {
      goods.push({
        width: 20,
        height: 10,
        length: 10,
        weight: 300 * product.count
      })
    })

    new window.CDEKWidget({
      from: 'Москва, Кутузовский проспект 1-1',
      root: 'cdek-map',
      apiKey: '1b1f192d-9460-4afb-8ae3-c8fb7643c1ba',
      servicePath: 'https://brunoaltro.ru/assets/sdek.php',
      hideFilters: {
        have_cashless: false,
        have_cash: false,
        is_dressing_room: false,
        type: true
      },
      goods: goods,
      lang: 'rus',
      currency: 'RUB',
      tariffs: {
        door: [ 233, 137, 294 ],
        office: [ 234, 136, 291 ],
        pickup: [ 368, 378 ]
      },
      defaultLocation: coords,
      onReady() {
        main.onReady()
      },
      onChoose( type, tarif, adres ) {
        main.onChoose( type, tarif, adres )
      }
    })
  }

  componentDidMount() {
    const main = this,
    geo = navigator.geolocation

    if( geo ) {
      const watcher = geo.watchPosition( ( data ) => {
        geo.clearWatch( watcher )
        main.setState( {
          coords: [ data.coords.longitude, data.coords.latitude ]
        })
      }, () => {

      }, {
        maximumAge: Infinity,
        timeout: 19500
      })
    }

    window.addEventListener('click', this.onClickOutsideHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onClickOutsideHandler);
  }

  onClickHandler() {
    this.setState({
      isOpen: true
    })
  }

  onClickOutsideHandler(event) {
    if (this.state.isOpen && !this.adresInput.current.contains(event.target)) {
      this.setState({ isOpen: false })
    }
  }

  closeAdres() {
    this.setState({
      isOpen: false
    })
  }

  render() {

    const { delivery, adres, modalShow, isOpen } = this.state,
    { ajax_data, priceFormat, delivery_price, sum } = this.props

    return (
      <>
        <div className={styles.korzina_form_title + ` d-flex align-items-end justify-content-between`}>
          <div>Способы доставки</div>
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 6L6 1L1 6" stroke="black"/>
          </svg>
        </div>
        <div className={styles.korzina_delivery_block + ` d-flex align-items-center`}>
          {ajax_data.deliverys.map( ( delivery_el, k ) => {
            if( delivery_el.id == 1 || delivery_el.id == 2 ) {
              if( delivery_el.id == delivery ) return (
                <div onClick={() => this.setDMethod( delivery_el.id )} key={k} className={styles.korzina_form_checkbox}>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                    <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                  </svg>
                  <div>
                    <div className={styles.korzina_form_checkbox_name_active}>{delivery_el.name}{delivery_price > 0 ? ` + ` + priceFormat(delivery_price) + `₽` : ``}</div>
                    <div>
                      <>{delivery_el.description}</>
                    </div>
                  </div>
                </div>
              )
              return (
                <div onClick={() => this.setDMethod( delivery_el.id )} key={k} className={styles.korzina_form_checkbox}>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                  </svg>
                  <div>
                    <div className={styles.korzina_form_checkbox_name}>{delivery_el.name}</div>
                    <div>
                      <>{delivery_el.description}</>
                    </div>
                  </div>
                </div>
              )
            } else if( delivery_el.id == 3 ) {
              if( adres == `` ) return
              if( sum < 2000 ) return
              let adresArr = adres.split(','),
              moscow = false
              adresArr.map(( part ) => {
                if( part.trim() == 'москва' || part.trim() == 'Москва' ) moscow = true
              })
              if( moscow ) return (
                <div onClick={() => this.setDMethod( delivery_el.id )} key={k} className={styles.korzina_form_checkbox}>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                    {delivery_el.id == delivery &&
                      <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                    }
                  </svg>
                  <div>
                    <div className={delivery_el.id == delivery ? styles.korzina_form_checkbox_name_active : styles.korzina_form_checkbox_name}>{delivery_el.name}{delivery_el.sum > 0 ? ` + ` + priceFormat(delivery_el.sum) + `₽` : ``}</div>
                    <div>
                      <>{delivery_el.description}</>
                    </div>
                  </div>
                </div>
              )
            } else {
              return (
                <div onClick={() => this.setDMethod( delivery_el.id )} key={k} className={styles.korzina_form_checkbox}>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="black" strokeWidth="0.75"/>
                    {delivery_el.id == delivery &&
                      <rect x="5" y="5" width="7" height="7" rx="3.5" fill="black"/>
                    }
                  </svg>
                  <div>
                    <div className={delivery_el.id == delivery ? styles.korzina_form_checkbox_name_active : styles.korzina_form_checkbox_name}>{delivery_el.name}{delivery_el.sum > 0 ? ` + ` + priceFormat(delivery_el.sum) + `₽` : ``}</div>
                    <div>
                      <>{delivery_el.description}</>
                    </div>
                  </div>
                </div>
              )
            }
          })}
        </div>
        {delivery < 5 &&
          <div className={styles.korzina_form_adres} ref={this.adresInput}>
            <Form.Control
              onClick={this.onClickHandler}
              value={adres}
              onChange={( e ) => this.findAdres( e.target.value )}
              className={styles.korzina_form_input}
              type="text"
              placeholder="Населенный пункт, улица, дом, кв"
              autoComplete="new-password"
            />
            {ajax_data.user.authorized &&
              <>
                {ajax_data.user.adres.length > 0 &&
                  <>
                    {isOpen &&
                      <ListGroup className={styles.korzina_form_adres_surgestions}>
                        {ajax_data.user.adres.map( ( str, k ) => {
                          return (
                            <ListGroup.Item key={k} onClick={() => {
                              this.closeAdres()
                              this.findAdres( str )
                            }}>{str}</ListGroup.Item>
                          )
                        } )}
                      </ListGroup>
                    }
                  </>
                }
              </>
            }
          </div>
        }
        <Modal
          size="xl"
          centered
          show={modalShow}
          onHide={() => this.setModalShow(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Доставка СДЕК
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='w-100' style={{ height: 600 }} id="cdek-map" />
          </Modal.Body>
        </Modal>
      </>
    )
  }
}
Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  priceFormat: PropTypes.func,
  setDelivery: PropTypes.func,
  delivery_price: PropTypes.number,
  cart: PropTypes.array,
  sum: PropTypes.number
}

/*
import { Component } from 'react'
import PropTypes from 'prop-types'

import { Spinner } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      adres: ``,
      delivery_arr: [],
      delivery: 1,
      delivery_loading: true,
      delivery_price: 0
    }
  }

  setDMethod( delivery ) {
    const { delivery_arr, adres } = this.state
    delivery_arr.map( ( el ) => {
      if( el.id == delivery ) {
        this.setState({
          delivery: el.id,
          delivery_price: el.sum
        }, () => {
          this.props.setDelivery(
            el.id, adres, el.sum
          )
        })
      }
    })
  }

  onReady( data ) {
    window.console.log( data )
    this.setState({
      delivery_loading: false
    })
  }

  onCalculate( data ) {
    window.console.log( data )
  }

  onChoose( type, tarif, adres ) {
    this.props.setDelivery(
      tarif.tariff_code,
      adres.name,
      tarif.delivery_sum
    )
    window.console.log( type, tarif, adres )
  }

  componentDidMount() {
    const main = this,
    { cart } = this.props,
    goods = []

    cart.map(( product ) => {
      goods.push({
        width: 20,
        height: 10,
        length: 10,
        weight: 300
      })
    })

    new window.CDEKWidget({
      from: 'Москва, Кутузовский проспект 1-1',
      root: 'cdek-map',
      apiKey: '1b1f192d-9460-4afb-8ae3-c8fb7643c1ba',
      servicePath: 'https://brunoaltro.ru/assets/sdek.php',
      hideFilters: {
        have_cashless: false,
        have_cash: false,
        is_dressing_room: false,
        type: false
      },
      goods: goods,
      lang: 'rus',
      currency: 'RUB',
      tariffs: {
        office: [234, 136, 138],
        door: [233, 137, 139],
      },
      defaultLocation: 'Москва',
      onReady( data ) {
        main.onReady( data )
      },
      onCalculate( data ) {
        main.onCalculate( data )
      },
      onChoose( type, tarif, adres ) {
        main.onChoose( type, tarif, adres )
      },
    })
  }

  render() {

    const { delivery_loading, delivery_arr, delivery } = this.state,
    { priceFormat, normalizeCountForm } = this.props

    return (
      <>
        <div className={styles.korzina_form_title + ` d-flex align-items-end justify-content-between`}>
          <div>Способы доставки</div>
          <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 6L6 1L1 6" stroke="black"/>
          </svg>
        </div>
        {delivery_loading &&
          <div style={{ height: 600 }} className={`d-flex align-items-center justify-content-center w-100`}>
            <Spinner animation="grow" variant="dark" />
          </div>
        }
        <div className={delivery_loading ? `d-none` : ``} style={{ height: 600 }} id="cdek-map" />
        <div className={styles.korzina_form_adres}>
          
        </div>
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  priceFormat: PropTypes.func,
  normalizeCountForm: PropTypes.func,
  setDelivery: PropTypes.func,
  cart: PropTypes.array
}
*/